import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import WatchList from './watchList';
import { getNSGlobalSettingsPageInfo } from '../../../redux/actions/settings';
import {
  getNSRIWatchListInitiate,
  getNSRIWatchListCoverageReportsInitiate
} from '../../../redux/actions/ns/runInstance';

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    settings: state.settings,
    watchListData: state.nsRunInstanceConfig.watchList
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path) => push(path),
        getNSGlobalSettingsPageInfo,
        getNSRIWatchListInitiate,
        getNSRIWatchListCoverageReportsInitiate
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WatchList);
